/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:18]
Permissions to update outside the main branch: [false]
*/

import { revoke } from 'axios/tokenApi';
import useApi from 'hooks/useApi';
import useAuth, { initialAuth } from 'hooks/useAuth';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Logout = () => {
    const location = useLocation();
    const { setAuth } = useAuth();
    const api = useApi();

    useEffect(() => {
        const revokeToken = async () => {
            await revoke(api);
        };
        revokeToken();
    }, []);

    setAuth(initialAuth);

    return <Navigate to="/" state={{ from: location }} replace />;
};

export default Logout;
